module.exports = __webpack_public_path__ + "c9671bb5a46a9df4974b1a588a09596c.jpg";